import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Menu } from "antd";
import { connect } from "react-redux";
import { setMenuAction } from "../redux/actions";
import { MenuOutlined } from "@ant-design/icons";

const style = {
  fontFamily: "Arial, Helvetica, sans-serif",
  paddingRight: 0,
  justifyContent: "flex-end",
  fontSize: "1.2em",
  borderBottom: 0,
};
const menuList = [
  {
    key: "/home",
    label: <Link to="/home">Home</Link>,
    // style,
  },
  {
    key: "/",
    label: "Portfolio",
    // style,
    children: [
      {
        key: "/visdev",
        label: <Link to="/visdev">VisDev Projects</Link>,
        style,
      },
      {
        key: "/gameart",
        label: <Link to="/gameart">Game Art</Link>,
        style,
      },
      {
        key: "/illustration",
        label: <Link to="/Illustration">Illustration</Link>,
        style,
      },
    ],
  },
  {
    key: "/aboutme",
    label: <Link to="/aboutme">About</Link>,
    // style,
  },
];

class Mmenu extends Component {
  state = {
    current: "/",
  };
  handleClick = (e) => {
    this.props.setmenu(e.key);
  };
  render() {
    const current = this.props.mmenu;
    return (
      <Menu
        mode="horizontal"
        onClick={this.handleClick}
        selectedKeys={current}
        overflowedIndicator={<MenuOutlined />}
        items={menuList}
        style={style}
      ></Menu>
    );
  }
}
export default connect(
  (state) => ({ menu: state.menu }),
  (dispatch) => {
    return {
      setmenu(key) {
        dispatch(setMenuAction(key));
      },
    };
  }
)(Mmenu);
